document.addEventListener("DOMContentLoaded", function() {

    let sp_price1 = 45.99
    let sp_price2 = 91.99
    const $priceDom = $('#sp_price1');
    const $cPriceDom = $('#sp_price2');
    const $offPriceDom = $('.price-group .font-off');
    const $numDom = $('#calcNumber');

    const productData = window.product || [];


    // 跳转支付页面
    $(document).on('click', '.sp-btn-style', function () {
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
    })

    /** 获取当前选中的变量 */
    function getCur() {
        const opts = {
            option1: $('#sp-opt-group1 div.active').attr('data-val'),
            option2: $('#sp-opt-group2 div.active').attr('data-val'),
            option3: $('#sp-opt-group3 div.active').attr('data-val')
        };

        return productData.find(item => {
            return (!opts.option1 || item.option1 == opts.option1) &&
                (!opts.option2 || item.option2 == opts.option2) &&
                (!opts.option3 || item.option3 == opts.option3);
        });
    }

    /** 更新价格显示 */
    function changePrice() {
        const curVariant = getCur();
        if (!curVariant) return;

        const num = parseInt($numDom.val()) || 1;

        // 识别当前页面使用的小数点符号
        const currentText = $priceDom.text().trim();
        const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

        const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
        const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

        // 格式化输出
        const formatValue = (cents) => {
            let val = (cents * num / 100).toFixed(decimalLength);
            if (decimalSeparator === ',') {
                val = val.replace('.', ',');
            }
            return val;
        };

        const price = formatValue(curVariant.price);
        const compare = formatValue(curVariant.compare_at_price);

        // 计算折扣
        let offPercent = 0;
        if (curVariant.compare_at_price > curVariant.price) {
            offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
        }

        const priceRegex = /\d+(?:[.,]\d+)*/;
        const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

        const updateHTML = ($el, regex, value) => {
            if ($el && $el.length) {
                const text = $el[0].textContent.trim();
                const newHtml = text.replace(regex, value);
                if ($el.html() !== newHtml) {
                    $el.html(newHtml);
                }
            }
        };

        updateHTML($priceDom, priceRegex, price);
        updateHTML($cPriceDom, priceRegex, compare);
        updateHTML($offPriceDom, offRegex, offPercent);
    }

    // 倒计�? 
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let endTimeG;

    function cutDownTime() {
        let nowTime = new Date();
        let endTime = new Date(endTimeG);

        let leftTime = endTime.getTime() - nowTime.getTime();
        if (leftTime < 0) {
            setupNewCountdown();
            leftTime = 0;
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60);
        leftH = leftH >= 10 ? leftH : "0" + leftH;
        leftM = leftM >= 10 ? leftM : "0" + leftM;
        leftS = leftS >= 10 ? leftS : "0" + leftS;

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        };
    }

    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9);
        const currentTime = new Date();
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;

    function getCutDownTime() {
        setupNewCountdown();
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(function() {
            let cutDownTimeText = cutDownTime();
            $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
            $(".sp_top_cut_down .sp_left_view .sp_minute").html(
                cutDownTimeText.minute
            );
            $(".sp_top_cut_down .sp_left_view .sp_second").html(
                cutDownTimeText.second
            );
        }, 1000);
    }

    getCutDownTime();

    new WOW().init();

    jQuery(".sp-scroll").slide({
        mainCell: ".nav-imgs",
        autoPlay: true,
        effect: "leftMarquee",
        interTime: 12,
        vis: 1,
        scroll: 1,
    });

    new Swiper('.mySwiper', {
        slidesPerView: 'auto',
        spaceBetween: 35,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时�?    
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        },
        allowTouchMove: false,
    })

    new Swiper(".sp-swiper1", {
        speed: 2000,
        autoplay: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
    });

    new Swiper(".sp-swiper2", {
        autoplay: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        pagination: {
            el: ".sp-pagination",
            clickable: true,
        },
    });

    // 移动端sp-part4对比图轮播 + 圆环联动
    var mobileRing = document.querySelector(".sp-part4.sp-mobile .sp-part4-ring");
    new Swiper(".sp-part4-compare-swiper", {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        on: {
            slideChange: function() {
                if (mobileRing) {
                    var angle = this.realIndex * 60;
                    mobileRing.style.transform = "rotate(" + angle + "deg)";
                }
            },
        },
    });

    // PC端sp-part4对比图轮播 + 圆环联动（垂直方向，中间完整+上下露出）
    var pcRing = document.querySelector(".sp-part4.sp-pc .sp-part4-ring");
    new Swiper(".sp-part4-compare-swiper-pc", {
        direction: "vertical",
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        on: {
            slideChange: function() {
                if (pcRing) {
                    var angle = this.realIndex * 60;
                    pcRing.style.transform = "rotate(" + angle + "deg)";
                }
            },
        },
    });

    // 移动端sp-part7步骤轮播
    new Swiper(".sp-part7-swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: ".sp-part7-nav-next",
            prevEl: ".sp-part7-nav-prev",
        },
    });

    new Swiper(".sp-swiper-fade", {
        spaceBetween: 10,
        effect: "fade",
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    });

    // Background swiper for sp-part1
    new Swiper(".sp-bg-swiper", {
        effect: "fade",
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        speed: 1000,
        loop: true,
        on: {
            init: function() {
                // 初始化时设置第一张的样式 - 移动端和PC端
                const infoCardMobile = document.querySelector('.sp-part1.sp-mobile .sp-info-card');
                const infoCardPC = document.querySelector('.sp-part1.sp-pc .sp-info-card');
                if (infoCardMobile) {
                    infoCardMobile.classList.remove('sp-dark-mode');
                }
                if (infoCardPC) {
                    infoCardPC.classList.remove('sp-dark-mode');
                }
            },
            slideChange: function() {
                const realIndex = this.realIndex;
                const infoCardMobile = document.querySelector('.sp-part1.sp-mobile .sp-info-card');
                const infoCardPC = document.querySelector('.sp-part1.sp-pc .sp-info-card');

                // 移动端
                if (infoCardMobile) {
                    if (realIndex === 0) {
                        infoCardMobile.classList.remove('sp-dark-mode');
                    } else {
                        infoCardMobile.classList.add('sp-dark-mode');
                    }
                }

                // PC端
                if (infoCardPC) {
                    if (realIndex === 0) {
                        infoCardPC.classList.remove('sp-dark-mode');
                    } else {
                        infoCardPC.classList.add('sp-dark-mode');
                    }
                }
            }
        }
    });

    new Swiper(".sp-swiper-fade1", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
        on: {
            slideChange: function(e) {
                e.slides.find(".sp-text").each(function() {
                    this.style.animation = "none";
                });
                const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
                if (spText) {
                    spText.style.animation = "none";

                    spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
                }
            },
        },
    });

    new Swiper(".sp-swiper0", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
    });

    function mainRender() {
        $(function() {
            $("#root").css("zoom", "normal");
            if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
            } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
            }

            window.addEventListener(
                "resize",
                (function() {
                    var timer;
                    return function() {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function() {
                            $("#root").css("zoom", "normal");
                            if (document.body.clientWidth <= 1060) {
                                let scale = document.body.clientWidth / 1080;
                                $("#root").css("zoom", scale);
                            } else {
                                const scale = document.body.clientWidth / 1920;
                                $("#root").css("zoom", scale);
                            }
                        }, 100);
                    };
                })()
            );
        });

        function lazyLoadImages() {
            // 懒加�?     
            const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图�?     
            const config = {
                rootMargin: "0px 0px 1300px 0px",
                threshold: 0,
            };

            const lazyLoadObserver = new IntersectionObserver(function(
                    entries,
                    observer
                ) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            // 当图片进入视口时
                            const image = entry.target;
                            const dataSrc = image.getAttribute("data-src");
                            if (dataSrc) {
                                image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                            }
                            lazyLoadObserver.unobserve(image); // 停止观察该图�?        
                        }
                    });
                },
                config);

            images.forEach(function(image) {
                lazyLoadObserver.observe(image); // 开始观察每个图�?     
            });
        }

        function preloadImages(imageArray) {
            // 预加�?      // 检查数组数据结�?    
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach((subArray) => {
                    subArray.forEach((url) => {
                        const img = new Image();
                        img.src = url;
                    });
                });
            } else {
                // 处理一维数�?     
                imageArray.forEach((url) => {
                    const img = new Image();
                    img.src = url;
                });
            }
        }

        lazyLoadImages();

        // let imgList = [];
        // for (let i = 1; i <= 2; i++) {
        //   imgList.push(`./image/20260303-p${i}.png`);
        // }

        // preloadImages(imgList);

        // 更新主图显示
        function updateMainImage() {
            // let colorIndex = $("#sp-color .sp-option.active").index();
            // // 更新图片
            // $(".sp-img-p").attr('src', imgList[colorIndex]);
        }

        // IOS字体多了间距的处�?   
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isAndroid = /android/i.test(userAgent);
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

        if (!isAndroid && !isIOS && !isPC) {
            $(".sp_system").css("letter-spacing", "-4px");
        }
    }

    mainRender();

    // Product swiper initialization
    const _swiper = new Swiper(".sp-swiper-pro", {
        slidesPerView: 1,
        spaceBetween: 100,
        allowTouchMove: false,
        speed: 0, // 设置为0，瞬间切换
        centeredSlides: true,
        watchSlidesProgress: true,
    });


    function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(2);
    }

    // 图片索引映射: { quantity: index }
    const imageIndexMap = {
        'buy1': 0, // Buy 1
        'buy2': 1, // Buy 2 Get 1 Free
        'buy3': 2, // Buy 1 + Hair Removal Oil
        'buy4': 3 // Buy 2 Get 1 Free + Hair Removal Oil
    };

    // 刮刀数量映射
    const scraperCountMap = {
        'buy1': 2,
        'buy2': 2,
        'buy3': 2,
        'buy4': 2
    };

    // 更新产品图片和价格
    function updateProductDisplay() {
        const $activeOption = $('#sp-opt-group1 .sp-option.active');
        const quantity = $activeOption.data('quantity');
        const price = $activeOption.data('price');
        const original = $activeOption.data('original');

        // 更新图片
        const imgIndex1 = $('#sp-opt-group1 .sp-option.active').index();
        const imgIndex2 = $('#sp-opt-group2 .sp-option.active').index();
        let imgIndex = imgIndex2 + imgIndex1*2
        _swiper.slideTo(imgIndex, 0);
        // 更新价格
        // if (price) {
        //     sp_price1 = parseFloat(price);
        //     sp_price2 = parseFloat(original);
        //     const calcNum = parseInt($('#calcNumber').val()) || 1;
        //     $('#sp_price1').html('$' + calcTotal(sp_price1, calcNum));
        //     $('#sp_price2').html('$' + calcTotal(sp_price2, calcNum));
        // }

        // 更新刮刀数量
        if (quantity && scraperCountMap[quantity]) {
            $('#sp-scraper-count').text(scraperCountMap[quantity]);
        }
    }

    // 数量选项点击事件
    $('.sp-option').on('click', function() {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        updateProductDisplay();
        changePrice()
    });

    // 初始化显示
    updateProductDisplay();

    // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工�? 
    function handleShoppingLinkClick(event) {
        const link = event.target.closest('a[href="#shopping"]');
        if (!link) return;

        event.preventDefault();

        const targetElement = document.getElementById("shopping");
        if (targetElement) {
            const offsetTop = targetElement.offsetTop;
            let sptop = document.body.clientWidth <= 1080 ? 138 : 200;
            let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
            const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

            window.scrollTo({
                top: scrollTop,
                behavior: "smooth",
            });

            setTimeout(() => {
                if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
                    $('html, body').animate({
                        scrollTop: scrollTop
                    }, 800);
                }
            }, 100);
        }
    }

    // 使用事件委托在document上监听所有点击
    document.addEventListener('click', handleShoppingLinkClick);

    $(".sp-reduce").click(function() {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
            input.value = num;
        }
        changePrice()
    });
    $(".sp-add").click(function() {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice()
    });

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll("span, div");
        const paragraph = gradually.querySelector(".sp-sub-title");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 给每�?span/div �?i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`;
                            span.style.animationDelay = `${index * 0.1}s`;

                            const i = span.querySelector("i");
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                                i.style.animationDelay = `${index * 0.1}s`;
                            }
                        });

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3;
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
                            paragraph.style.animationDelay = `${totalDelay}s`;
                        }

                        observer.unobserve(gradually);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observer.observe(gradually);
    }

    // 菜单
    $(".sp-menu-btn").click(function(e) {
        $(".sp-menu-mask").show();
    });

    $(".sp-menu-mask").click(function(e) {
        $(".sp-menu-mask").hide();
    });

    function getZoomValue() {
        let zoom = $("div#root").css("zoom");
        return parseFloat(zoom) || 1;
    }

    function handleScroll() {
        // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        // let zoomValue = getZoomValue();
        // let headerHeight = $(".header:visible").height() * zoomValue;

        // if (scrollTop > headerHeight) {
        //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
        // } else {
        //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
        // }
    }

    // 初始检�?  handleScroll();

    // 监听多种滚动事件
    window.addEventListener('scroll', handleScroll, true);
    document.addEventListener('scroll', handleScroll, true);

    $(function() {
        // 判断是否为移动端
        function isMobile() {
            return document.body.clientWidth <= 1060;
        }

        // 购物车加购动�?   
        $(".cart-btn").click(function() {
            $(this).children("img").addClass("on");
            if (isMobile()) {
                $(".sp-mobile .sp-cart .num").show();
                $(".sp-mobile .sp-cart").addClass("on");
                setTimeout(function() {
                    $(".sp-mobile .sp-cart").removeClass("on");
                }, 500);
            } else {
                $(".sp-pc .sp-header-top .sp-cart .num").show();
                $(".sp-pc .sp-header-top .sp-cart").addClass("on");
                setTimeout(function() {
                    $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
                }, 500);
            }
            setTimeout(function() {
                $(".cart-btn").children("img").removeClass("on");
            }, 500);
        });

        let initNum = 0;

        $(".product-part .cart-btn").click(function() {
            var data = {
            id: getCur().id,
            quantity:$('#calcNumber').val(),
        };
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            success: function () {
                $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                    // $("#cardNum").html(result.item_count);
                    console.log("result", result.item_count)
                    initNum = result.item_count
                    // 更新购物车数量
                    $('.cardNum').each(function () {
                        $(this).html(initNum)
                    })
                    $('.cardNum').removeClass('sp-gray')
                });
            },
            dataType: "json",
        });

            // 加购飞入：主图飞向购物车数字角标
            var $flyImg = $(".product-part .sp-img-wrap .swiper-slide-active .sp-combo-wrap");
            if ($flyImg.length === 0) return;
            var rect = $flyImg[0].getBoundingClientRect();

            var flyer = $flyImg[0].cloneNode(true);
            flyer.classList.add("sp_clone");
            $("body").append(flyer);
            $(flyer).css({
                position: "fixed",
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height,
                margin: 0,
                "z-index": 9999,
                "pointer-events": "none",
                "object-fit": "contain",
            });

            var $numEl = isMobile() ?
                $(".sp-btn-style2.sp-mobile .sp-cart .sp-num") :
                $(".sp-pc .sp-header-top .sp-cart .sp-num");
            var targetTop = rect.top;
            var targetLeft = rect.left;
            if ($numEl.length > 0) {
                var numRect = $numEl[0].getBoundingClientRect();
                targetTop = numRect.top + numRect.height / 2 - 25;
                targetLeft = numRect.left + numRect.width / 2 - 25;
            }

            $(flyer).animate({
                    top: targetTop,
                    left: targetLeft,
                    width: 50,
                    height: 50,
                    opacity: 0.4,
                },
                700,
                "swing",
                function() {
                    $(this).animate({
                            width: 0,
                            height: 0,
                            opacity: 0
                        },
                        0,
                        function() {
                            $(this).detach();
                        }
                    );
                }
            );
        });
    });

    // 问答
    $(".q-row").click(function() {
        $(this).parent().toggleClass("sp-show");
    });

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName("sp-fade-box");
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll(".sp-ani");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`;
                        });

                        observerAni.unobserve(gradually2);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observerAni.observe(gradually2);
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.3 + 1}s`;
                        });

                        observerAni.unobserve(gradually3);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observerAni.observe(gradually3);
    }

});